// Mock data for HART - will be replaced by backend API later

export const plans = [
  {
    id: "memory",
    name: "Memory",
    tagline: "A lasting tribute page. Lives forever.",
    price: "$10",
    period: "one-time",
    cta: "Create a Memory",
    highlight: false,
    features: [
      "Photo, name & their story",
      "Public guestbook",
      "One shareable link",
      "Stays online indefinitely",
    ],
  },
  {
    id: "care",
    name: "Care",
    tagline: "The full living page for an active care journey.",
    price: "$29",
    period: "per month",
    cta: "Start with Care",
    highlight: true,
    badge: "Most loved",
    features: [
      "Everything in Memory",
      "Live updates feed",
      "Needs board (meals, rides, prayers)",
      "Photo wall — anyone can contribute",
      "Calendar of milestones",
      "Community message wall",
    ],
  },
  {
    id: "circle",
    name: "Circle",
    tagline: "For families managing complex care.",
    price: "$75",
    period: "per month",
    cta: "Choose Circle",
    highlight: false,
    features: [
      "Everything in Care",
      "Private password-protected sections",
      "MyChart credentials vault",
      "Push notifications to family",
      "Custom domain (e.g. hedgesforann.com)",
      "Up to 10 caregiver logins",
      "Priority support & onboarding call",
    ],
  },
  {
    id: "whitelabel",
    name: "For Partners",
    tagline: "For churches & faith families, pediatricians, hospice teams, and care navigators.",
    price: "Custom",
    period: "white-label",
    cta: "Contact us",
    highlight: false,
    providerBadge: "For partners",
    features: [
      "Full website design for multiple families",
      "White-labeled — your name, your branding",
      "Add family pages to your own website & domain",
      "Faith family sections with services & live streams",
      "Bulk family onboarding",
      "Partner dashboard across all your families",
      "HIPAA-aligned hosting agreement",
      "Custom integrations & onboarding call",
    ],
  },
];

export const mockPerson = {
  slug: "ann-fisher",
  firstName: "Ann",
  lastName: "Fisher",
  fullName: "Ann Fisher",
  passcode: "1234",
  photo:
    "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=60",
  story:
    "Ann is a mother, grandmother, and the heart of every room she walks into. She's currently in treatment at Riverside Medical, and this page is where her people gather — to stay close, stay informed, and show up in the ways that matter.",
  updates: [
    {
      id: "u1",
      author: "Sarah (daughter)",
      date: "2025-07-14",
      title: "A good week",
      body: "Mom finished her third round on Tuesday and the doctors are pleased with how she's responding. She's tired but in good spirits — she even asked for her crossword puzzles back, which we're taking as a very good sign.",
    },
    {
      id: "u2",
      author: "Mike (son)",
      date: "2025-07-08",
      title: "Round three starts tomorrow",
      body: "Mom heads back to Riverside tomorrow morning for round three. She's feeling ready. Thank you to everyone who dropped off meals last week — the freezer is full and so are our hearts.",
    },
    {
      id: "u3",
      author: "Sarah (daughter)",
      date: "2025-06-30",
      title: "Scan results are in",
      body: "The scans show the treatment is working. There's still a road ahead, but today we're celebrating. Mom wants everyone to know she reads every single message on this page.",
    },
  ],
  needs: [
    {
      id: "n1",
      type: "meal",
      title: "Dinner drop-off — Thursday, July 24",
      details: "No dairy please. Porch drop-off is perfect, around 5pm.",
      claimedBy: null,
    },
    {
      id: "n2",
      type: "ride",
      title: "Ride to Riverside Medical — Monday, July 28",
      details: "Appointment at 10:30am. Pickup from the house around 9:45.",
      claimedBy: "Karen L.",
    },
    {
      id: "n3",
      type: "errand",
      title: "Pharmacy pickup — this week",
      details: "Prescription is ready at the Walgreens on 5th. Any day works.",
      claimedBy: null,
    },
    {
      id: "n4",
      type: "prayer",
      title: "Prayers for Tuesday's appointment",
      details: "Big consult with the oncology team Tuesday at 2pm. Hold her close.",
      claimedBy: null,
    },
  ],
  photos: [
    {
      id: "p1",
      url: "https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=600&q=60",
      caption: "Family picnic, June",
      by: "Sarah",
    },
    {
      id: "p2",
      url: "https://images.unsplash.com/photo-1511895426328-dc8714191300?w=600&q=60",
      caption: "Grandkids visit",
      by: "Mike",
    },
    {
      id: "p3",
      url: "https://images.unsplash.com/photo-1476703993599-0035a21b17a9?w=600&q=60",
      caption: "Morning walk together",
      by: "Karen",
    },
    {
      id: "p4",
      url: "https://images.unsplash.com/photo-1470116945706-e6bf5d5a53ca?w=600&q=60",
      caption: "Her garden this spring",
      by: "Ann",
    },
  ],
  messages: [
    {
      id: "m1",
      name: "Karen L.",
      date: "2025-07-15",
      body: "Ann, you are the strongest woman I know. Dinner's on me next week — no arguments.",
    },
    {
      id: "m2",
      name: "Pastor Jim",
      date: "2025-07-12",
      body: "The whole congregation is holding you in prayer, Ann. We love you.",
    },
    {
      id: "m3",
      name: "The Hendersons",
      date: "2025-07-10",
      body: "Thinking of you every day. The kids made you cards — dropping them off this weekend!",
    },
  ],
  milestones: [
    { id: "e1", date: "2025-07-22", title: "Oncology consult", note: "2:00pm at Riverside Medical" },
    { id: "e2", date: "2025-07-28", title: "Round four begins", note: "10:30am — Karen driving" },
    { id: "e3", date: "2025-08-05", title: "Follow-up scans", note: "Results expected within the week" },
    { id: "e4", date: "2025-08-16", title: "Ann's birthday", note: "Let's make it special" },
  ],
};

export const needTypeLabels = {
  meal: "Meal",
  ride: "Ride",
  errand: "Errand",
  prayer: "Prayer",
  presence: "Presence",
};
